<template>
  <div class="sidebar">
    <div class="row mb-5 mt-3">
      <img src="/img/arrow-left.svg" height="30" @click="$router.back()" />
      <div class="col-12 text-center">
        <img src="/img/selo-color.svg" height="100" @click="$router.replace('main')" />
      </div>
    </div>
    <div class="page-container">
      <div class="sidebar-item" @click="confirmarPresenca">
        <i class="fas fa-calendar-check"></i>
        <div class="item-content">
          <span class="item-title">Confirmar presença no evento</span>
        </div>
      </div>
      <div class="sidebar-item" @click="entrarComunidade">
        <i class="fab fa-whatsapp"></i>
        <div class="item-content">
          <span class="item-title">Entrar na comunidade</span>
          <span class="item-subtitle">Comunidade no WhatsApp</span>
        </div>
      </div>
      <div class="sidebar-item" @click="pesquisaSatisfacao">
        <i class="fas fa-poll"></i>
        <div class="item-content">
          <span class="item-title">Pesquisa de Satisfação</span>
          <span class="item-subtitle">Responda a pesquisa de satisfação</span>
        </div>
      </div>
      <div class="sidebar-item" @click="editarInformacoes">
        <i class="fas fa-pen"></i>
        <div class="item-content">
          <span class="item-title">Editar suas informações</span>
          <span class="item-subtitle">Edite suas informações de cadastro</span>
        </div>
      </div>
      <!-- <div class="sidebar-item" @click="receberNotificacoes">
      <i class="fas fa-bell"></i>
      <div class="item-content">
        <span class="item-title">Receba Notificações do Projeto</span>
        <span class="item-subtitle">Receba notificação</span>
      </div>
    </div> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  created() {
    const idUsuario = window.sessionStorage.getItem("idUsuario");

    if (idUsuario === null || idUsuario === undefined || idUsuario === "undefined" || idUsuario === "") {
      this.$router.push("/login");
    } else {
      const parsedIdCliente = JSON.parse(idUsuario);
      this.idUsuario = parsedIdCliente;
    }

  },
  data() {
    return {
      idUsuario: null,
    };
  },
  methods: {
    confirmarPresenca() {
      this.$router.push("/confirmacao");
    },
    entrarComunidade() {
      window.open(
        "https://chat.whatsapp.com/K2AuKfzGAZK6n3xUl3sTgR",
        "_blank"
      );
    },
    pesquisaSatisfacao() {
      this.$router.push("/pesquisa");
    },
    editarInformacoes() {
      this.$router.push("/registro");
    },
    receberNotificacoes() {
      alert('Notificações ativadas!');
    }
  }
}
</script>

<style scoped>
.page-container {
  min-height: 50vh !important;
  justify-content: flex-end;
}

.container {
  flex: 1 !important;
}

.sidebar {
  background-color: #F1F9FF;
  /* Fundo azul */
  padding: 15px;
  height: 100vh;
  /* Ocupa a altura total da tela */
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  /* Sombra para dar profundidade */
}

.sidebar-item {
  padding: 10px;
  margin: 15px 0;
  background-color: #fff;
  /* Fundo branco para os itens */
  border-radius: 5px;
  /* Bordas arredondadas para os itens */
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: background-color 0.3s ease;
}

.sidebar-item:hover {
  background-color: #2699FB;
  /* Cor de fundo ao passar o mouse */
}

.sidebar-item i {
  margin-right: 10px;
  font-size: 1.2em;
  color: #2699FB;
  /* Cor azul para os ícones */
  background-color: #0D4275;
  /* Fundo claro para os ícones */
  padding: 10px;
  border-radius: 50%;
  /* Ícones redondos */
}

.item-content {
  display: flex;
  flex-direction: column;
}

.item-title {
  font-weight: bold;
  display: block;
  color: #0D4275;
  font-size: 15px;
  /* Cor do título */
}

.item-subtitle {
  font-size: 0.7em;
  color: #0D4275;
  /* Cor do subtítulo */
  display: block;
}
</style>